import * as mns from '../../mutation-types';

export default {
    state () {
        return {
            contractNumber: '',
            contractDate: '',
            lastName: '',
            name: '',
            patronymic: ''
        }
    },
    getters: {
        contractNumber(state){
            return state.contractNumber;
        },
        contractDate(state){
            return state.contractDate;
        },
        lastName(state){
            return state.lastName;
        },
        name(state){
            return state.name;
        },
        patronymic(state){
            return state.patronymic;
        },
    },
    mutations: {
        [mns.SET_CONTRACT_NUMBER](state, value){
            state.contractNumber = value;
        },
        [mns.SET_CONTRACT_DATE](state, value){
            state.contractDate = value;
        },
        [mns.SET_LAST_NAME](state, value){
            state.lastName = value;
        },
        [mns.SET_NAME](state, value){
            state.name = value;
        },
        [mns.SET_PATRONYMIC](state, value){
            state.patronymic = value;
        },
    }
} // export.